import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  FormGroup,
  Badge,
} from "reactstrap";
import axios from "axios";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { API_TIMEOUT, API_DARAH_MASUK, API_DONOR_DARAH } from "utils";
import { logApp } from "utils/func";

function DarahMasuk() {
  const [tabelData, setTabelData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [currentUser, setCurrentUser] = useState("");
  const history = useHistory();
  const [saveLoading, setSaveLoading] = useState(false);

  // Form state
  const [id, setId] = useState("");
  const [id_donors, setIdDonors] = useState("");
  const [tanggal, setTanggal] = useState("");
  const [tujuan, setTujuan] = useState("");
  const [jumlah_kantung, setJumlahKantung] = useState("");
  const [blood_type, setBloodType] = useState("");

  // Dropdown data
  const [listDonors, setListDonors] = useState([]);
  const [listBloodTypes, setListBloodTypes] = useState([]);
  // Helper: konversi ISO dengan Z ke YYYY-MM-DD lokal
  const toLocalDateString = (isoString) => {
    const d = new Date(isoString);
    if (Number.isNaN(d.getTime())) return "";
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Format untuk input date (hindari shift timezone)
  const formatDateInput = (value) => {
    if (!value) return "";
    const str = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return str;
    if (/^\d{4}-\d{2}-\d{2}T.*Z$/.test(str)) {
      const local = toLocalDateString(str);
      if (local) return local;
    }
    if (str.includes("T")) {
      const datePart = str.split("T")[0];
      if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return datePart;
      const local = toLocalDateString(str);
      if (local) return local;
    }
    if (str.includes(" ")) {
      const datePart = str.split(" ")[0];
      if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return datePart;
    }
    const pat1 = /^(\d{2})[\/\-](\d{2})[\/\-](\d{4})$/;
    const m1 = str.match(pat1);
    if (m1) {
      const [, d, m, y] = m1;
      return `${y}-${m}-${d}`;
    }
    const pat2 = /^(\d{4})[\/](\d{2})[\/](\d{2})$/;
    const m2 = str.match(pat2);
    if (m2) {
      const [, y, m, d] = m2;
      return `${y}-${m}-${d}`;
    }
    const pat3 = /(\d{4}-\d{2}-\d{2})/;
    const m3 = str.match(pat3);
    if (m3) return m3[1];
    return str;
  };

  // Format untuk tampilan tabel
  const formatDateDisplay = (value) => {
    if (!value) return "-";
    const str = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}T.*Z$/.test(str)) {
      const local = toLocalDateString(str);
      if (local) return formatDateDisplay(local);
    }
    const datePart = str.includes("T")
      ? str.split("T")[0]
      : str.includes(" ")
      ? str.split(" ")[0]
      : str;
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
    if (match) {
      const [, y, m, d] = match;
      const bulan = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agu",
        "Sep",
        "Okt",
        "Nov",
        "Des",
      ];
      const monthName = bulan[parseInt(m, 10) - 1] || m;
      return `${d} ${monthName} ${y}`;
    }
    return datePart;
  };

  // Searchable dropdown state
  const [donorSearchTerm, setDonorSearchTerm] = useState("");
  const [showDonorDropdown, setShowDonorDropdown] = useState(false);
  const [selectedDonorName, setSelectedDonorName] = useState("");

  useEffect(() => {
    if (!currentUser) {
      let user = localStorage.getItem("user");
      if (user) {
        user = JSON.parse(user);
        setCurrentUser(user);
        logApp(user.uid, "Darah Masuk");
      } else {
        history.push("/login");
      }
    }
    getListDonors();
    getListBloodTypes();
    fetchData();
  }, []);

  // Handle click outside untuk menutup dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest("[data-donor-dropdown]")) {
        setShowDonorDropdown(false);
      }
    };

    if (showDonorDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDonorDropdown]);

  const fetchData = () => {
    axios({
      method: "get",
      url: API_DARAH_MASUK,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          // Normalisasi tanggal agar tidak bergeser timezone
          const normalized = response.data.data.map((item) => {
            if (item.tanggal) {
              const str = String(item.tanggal);
              if (/^\d{4}-\d{2}-\d{2}T.*Z$/.test(str)) {
                item.tanggal = toLocalDateString(str);
              } else if (str.includes("T")) {
                item.tanggal = str.split("T")[0];
              } else if (str.includes(" ")) {
                item.tanggal = str.split(" ")[0];
              }
            }
            return item;
          });
          setTabelData(normalized);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        swal("Error", "Gagal mengambil data", "error");
      });
  };

  const getListDonors = async () => {
    try {
      // Ambil dari data_donor untuk dropdown (karena belum ada endpoint khusus donors)
      const response = await axios.get(API_DONOR_DARAH + "donatur");
      if (response.data.success && response.data.data) {
        // Map data untuk dropdown, gunakan id sebagai donorID sementara
        // Catatan: Di production, sebaiknya buat endpoint khusus untuk donors dengan donorID
        const mappedData = response.data.data.map((item) => ({
          ...item,
          donorID: item.id, // Gunakan id dari data_donor sebagai donorID
        }));
        setListDonors(mappedData);
      }
    } catch (error) {
      console.error("Error fetching donors:", error);
    }
  };

  // Filter donors berdasarkan search term (nama atau nomor HP)
  const filteredDonors = listDonors.filter((donor) => {
    const searchLower = donorSearchTerm.toLowerCase();
    const namaMatch = donor.nama?.toLowerCase().includes(searchLower) || false;
    const hpMatch = donor.noHp?.toLowerCase().includes(searchLower) || false;
    const bloodMatch =
      donor.bloodTypes?.toLowerCase().includes(searchLower) || false;
    return namaMatch || hpMatch || bloodMatch;
  });

  const handleDonorSelect = (donor) => {
    setIdDonors(donor.donorID || donor.id);
    setSelectedDonorName(`${donor.nama} - ${donor.bloodTypes}`);
    setDonorSearchTerm(`${donor.nama} - ${donor.bloodTypes}`);
    setShowDonorDropdown(false);
  };

  const handleDonorSearchChange = (e) => {
    const value = e.target.value;
    setDonorSearchTerm(value);
    setShowDonorDropdown(true);
    if (!value) {
      setIdDonors("");
      setSelectedDonorName("");
    }
  };

  const getListBloodTypes = async () => {
    try {
      const response = await axios.get(API_DONOR_DARAH + "bloodtypes");
      if (response.data.success && response.data.data) {
        setListBloodTypes(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching blood types:", error);
    }
  };

  const handleOpenModal = () => {
    resetForm();
    setModalOpen(true);
  };

  const handleOpenEdit = (item) => {
    setId(item.id);
    setIdDonors(item.id_donors || "");
    setTanggal(formatDateInput(item.tanggal) || "");
    setTujuan(item.tujuan || "");
    setJumlahKantung(item.jumlah_kantung || "");
    setBloodType(item.blood_type || "");

    // Set donor name untuk edit
    const donor = listDonors.find(
      (d) => (d.donorID || d.id) === item.id_donors
    );
    if (donor) {
      setSelectedDonorName(`${donor.nama} - ${donor.bloodTypes}`);
      setDonorSearchTerm(`${donor.nama} - ${donor.bloodTypes}`);
    } else {
      setSelectedDonorName("");
      setDonorSearchTerm("");
    }

    setModalEdit(true);
  };

  const resetForm = () => {
    setId("");
    setIdDonors("");
    setTanggal("");
    setTujuan("");
    setJumlahKantung("");
    setBloodType("");
    setDonorSearchTerm("");
    setSelectedDonorName("");
    setShowDonorDropdown(false);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalEdit(false);
    resetForm();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!id_donors || !tanggal || !jumlah_kantung || !blood_type) {
      swal("Info", "Semua field wajib harus diisi", "info");
      return;
    }

    if (parseInt(jumlah_kantung) <= 0) {
      swal("Info", "Jumlah kantung harus lebih dari 0", "info");
      return;
    }

    setSaveLoading(true);

    const data = {
      id_donors: parseInt(id_donors),
      tanggal: tanggal,
      tujuan: tujuan || null,
      jumlah_kantung: parseInt(jumlah_kantung),
      id_petugas_input: currentUser.id || 1,
      blood_type: parseInt(blood_type),
    };

    try {
      const response = await axios({
        method: "post",
        url: API_DARAH_MASUK,
        data: data,
        timeout: API_TIMEOUT,
      });

      if (response.status === 201 && response.data.success) {
        swal(
          "Success",
          response.data.message || "Data berhasil ditambahkan",
          "success"
        );
        fetchData();
        handleCloseModal();
      } else {
        swal(
          "Error",
          response.data.message || "Gagal menambahkan data",
          "error"
        );
      }
    } catch (error) {
      console.error("Error:", error);
      swal(
        "Error",
        error.response?.data?.message || "Terjadi kesalahan",
        "error"
      );
    } finally {
      setSaveLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!id_donors || !tanggal || !jumlah_kantung || !blood_type) {
      swal("Info", "Semua field wajib harus diisi", "info");
      return;
    }

    if (parseInt(jumlah_kantung) <= 0) {
      swal("Info", "Jumlah kantung harus lebih dari 0", "info");
      return;
    }

    setSaveLoading(true);

    const data = {
      id_donors: parseInt(id_donors),
      tanggal: tanggal,
      tujuan: tujuan || null,
      jumlah_kantung: parseInt(jumlah_kantung),
      id_petugas_input: currentUser.id || 1,
      blood_type: parseInt(blood_type),
    };

    try {
      const response = await axios({
        method: "put",
        url: `${API_DARAH_MASUK}/${id}`,
        data: data,
        timeout: API_TIMEOUT,
      });

      if (response.status === 200 && response.data.success) {
        swal(
          "Success",
          response.data.message || "Data berhasil diupdate",
          "success"
        );
        fetchData();
        handleCloseModal();
      } else {
        swal(
          "Error",
          response.data.message || "Gagal mengupdate data",
          "error"
        );
      }
    } catch (error) {
      console.error("Error:", error);
      swal(
        "Error",
        error.response?.data?.message || "Terjadi kesalahan",
        "error"
      );
    } finally {
      setSaveLoading(false);
    }
  };

  const handleDelete = (item) => {
    swal({
      title: "Apakah Anda yakin?",
      text: "Data yang dihapus tidak dapat dikembalikan!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await axios({
            method: "delete",
            url: `${API_DARAH_MASUK}/${item.id}`,
            timeout: API_TIMEOUT,
          });

          if (response.status === 200 && response.data.success) {
            swal(
              "Success",
              response.data.message || "Data berhasil dihapus",
              "success"
            );
            fetchData();
          } else {
            swal(
              "Error",
              response.data.message || "Gagal menghapus data",
              "error"
            );
          }
        } catch (error) {
          console.error("Error:", error);
          swal(
            "Error",
            error.response?.data?.message || "Terjadi kesalahan",
            "error"
          );
        }
      }
    });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <CardTitle tag="h4">
                  Data Darah Masuk <Badge color="success">Bank Darah</Badge>
                </CardTitle>
                <Button color="primary" onClick={handleOpenModal}>
                  <i className="tim-icons icon-simple-add" /> Tambah Data
                </Button>
              </CardHeader>
              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>No</th>
                      <th>Tanggal</th>
                      <th>Donor</th>
                      <th>Golongan Darah</th>
                      <th>Jumlah Kantung</th>
                      <th>Tujuan</th>
                      <th>Petugas</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tabelData && tabelData.length > 0 ? (
                      tabelData.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{formatDateDisplay(item.tanggal)}</td>
                          <td>
                            <div style={{ lineHeight: "1.2" }}>
                              <div>{item.nama_donor || "-"}</div>
                              {(item.golongan_darah_donor ||
                                item.no_hp_donor) && (
                                <small className="text-muted">
                                  {item.golongan_darah_donor || ""}
                                  {item.golongan_darah_donor && item.no_hp_donor
                                    ? " | "
                                    : ""}
                                  {item.no_hp_donor || ""}
                                </small>
                              )}
                            </div>
                          </td>
                          <td>
                            <Badge color="info">
                              {item.golonganDarah || "-"}
                            </Badge>
                          </td>
                          <td>{item.jumlah_kantung}</td>
                          <td>{item.tujuan || "-"}</td>
                          <td>{item.nama_petugas || "-"}</td>
                          <td>
                            <Button
                              color="warning"
                              size="sm"
                              onClick={() => handleOpenEdit(item)}
                              style={{ marginRight: 5 }}
                            >
                              <i className="tim-icons icon-pencil" />
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleDelete(item)}
                            >
                              <i className="tim-icons icon-simple-remove" />
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          Tidak ada data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal Tambah */}
        <Modal isOpen={modalOpen} toggle={handleCloseModal} size="lg">
          <ModalHeader toggle={handleCloseModal}>
            Tambah Data Darah Masuk
          </ModalHeader>
          <form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label>Donor *</Label>
                <div style={{ position: "relative" }} data-donor-dropdown>
                  <Input
                    type="text"
                    value={donorSearchTerm}
                    onChange={handleDonorSearchChange}
                    onFocus={() => setShowDonorDropdown(true)}
                    placeholder="Cari berdasarkan nama atau nomor HP..."
                    required={!id_donors}
                  />
                  {showDonorDropdown &&
                    donorSearchTerm &&
                    filteredDonors.length > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          zIndex: 1000,
                          backgroundColor: "white",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          marginTop: "2px",
                        }}
                      >
                        {filteredDonors.map((donor) => (
                          <div
                            key={donor.id}
                            onClick={() => handleDonorSelect(donor)}
                            style={{
                              padding: "10px 15px",
                              cursor: "pointer",
                              borderBottom: "1px solid #f0f0f0",
                              transition: "background-color 0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#f8f9fa";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "white";
                            }}
                          >
                            <div
                              style={{ fontWeight: "bold", color: "#2d3436" }}
                            >
                              {donor.nama}
                            </div>
                            <div style={{ fontSize: "12px", color: "#636e72" }}>
                              {donor.bloodTypes} | {donor.noHp || "-"}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  {showDonorDropdown &&
                    donorSearchTerm &&
                    filteredDonors.length === 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          zIndex: 1000,
                          backgroundColor: "white",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          padding: "10px 15px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          marginTop: "2px",
                          color: "#636e72",
                        }}
                      >
                        Tidak ada donor yang ditemukan
                      </div>
                    )}
                </div>
                {selectedDonorName && (
                  <small
                    className="text-muted"
                    style={{ display: "block", marginTop: "5px" }}
                  >
                    Terpilih: {selectedDonorName}
                  </small>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Tanggal *</Label>
                <Input
                  type="date"
                  value={tanggal}
                  onChange={(e) => setTanggal(e.target.value)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Golongan Darah *</Label>
                <Input
                  type="select"
                  value={blood_type}
                  onChange={(e) => setBloodType(e.target.value)}
                  required
                >
                  <option value="">Pilih Golongan Darah</option>
                  {listBloodTypes.map((bt) => (
                    <option key={bt.bloodTypeID} value={bt.bloodTypeID}>
                      {bt.golonganDarah}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Jumlah Kantung *</Label>
                <Input
                  type="number"
                  min="1"
                  value={jumlah_kantung}
                  onChange={(e) => setJumlahKantung(e.target.value)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Tujuan</Label>
                <Input
                  type="text"
                  value={tujuan}
                  onChange={(e) => setTujuan(e.target.value)}
                  placeholder="Contoh: Stok bank darah"
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={handleCloseModal}>
                Batal
              </Button>
              <Button color="primary" type="submit" disabled={saveLoading}>
                {saveLoading ? "Menyimpan..." : "Simpan"}
              </Button>
            </ModalFooter>
          </form>
        </Modal>

        {/* Modal Edit */}
        <Modal isOpen={modalEdit} toggle={handleCloseModal} size="lg">
          <ModalHeader toggle={handleCloseModal}>
            Edit Data Darah Masuk
          </ModalHeader>
          <form onSubmit={handleUpdate}>
            <ModalBody>
              <FormGroup>
                <Label>Donor *</Label>
                <div style={{ position: "relative" }} data-donor-dropdown>
                  <Input
                    type="text"
                    value={donorSearchTerm}
                    onChange={handleDonorSearchChange}
                    onFocus={() => setShowDonorDropdown(true)}
                    placeholder="Cari berdasarkan nama atau nomor HP..."
                    required={!id_donors}
                  />
                  {showDonorDropdown &&
                    donorSearchTerm &&
                    filteredDonors.length > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          zIndex: 1000,
                          backgroundColor: "white",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          marginTop: "2px",
                        }}
                      >
                        {filteredDonors.map((donor) => (
                          <div
                            key={donor.id}
                            onClick={() => handleDonorSelect(donor)}
                            style={{
                              padding: "10px 15px",
                              cursor: "pointer",
                              borderBottom: "1px solid #f0f0f0",
                              transition: "background-color 0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#f8f9fa";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "white";
                            }}
                          >
                            <div
                              style={{ fontWeight: "bold", color: "#2d3436" }}
                            >
                              {donor.nama}
                            </div>
                            <div style={{ fontSize: "12px", color: "#636e72" }}>
                              {donor.bloodTypes} | {donor.noHp || "-"}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  {showDonorDropdown &&
                    donorSearchTerm &&
                    filteredDonors.length === 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          zIndex: 1000,
                          backgroundColor: "white",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          padding: "10px 15px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          marginTop: "2px",
                          color: "#636e72",
                        }}
                      >
                        Tidak ada donor yang ditemukan
                      </div>
                    )}
                </div>
                {selectedDonorName && (
                  <small
                    className="text-muted"
                    style={{ display: "block", marginTop: "5px" }}
                  >
                    Terpilih: {selectedDonorName}
                  </small>
                )}
              </FormGroup>
              <FormGroup>
                <Label>Tanggal *</Label>
                <Input
                  type="date"
                  value={tanggal}
                  onChange={(e) => setTanggal(e.target.value)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Golongan Darah *</Label>
                <Input
                  type="select"
                  value={blood_type}
                  onChange={(e) => setBloodType(e.target.value)}
                  required
                >
                  <option value="">Pilih Golongan Darah</option>
                  {listBloodTypes.map((bt) => (
                    <option key={bt.bloodTypeID} value={bt.bloodTypeID}>
                      {bt.golonganDarah}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Jumlah Kantung *</Label>
                <Input
                  type="number"
                  min="1"
                  value={jumlah_kantung}
                  onChange={(e) => setJumlahKantung(e.target.value)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Tujuan</Label>
                <Input
                  type="text"
                  value={tujuan}
                  onChange={(e) => setTujuan(e.target.value)}
                  placeholder="Contoh: Stok bank darah"
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={handleCloseModal}>
                Batal
              </Button>
              <Button color="primary" type="submit" disabled={saveLoading}>
                {saveLoading ? "Mengupdate..." : "Update"}
              </Button>
            </ModalFooter>
          </form>
        </Modal>
      </div>
    </>
  );
}

export default DarahMasuk;
